import { z } from 'zod';

export const fullNameSchema = z.object({
  first_name: z.string(),
  last_name: z.string().nullable(),
  patronymic: z.string().nullable().optional(),
});

export const transformFullNameSchema = fullNameSchema.transform((raw) => {
  return {
    lastName: raw.last_name,
    firstName: raw.first_name,
    patronymic: raw.patronymic,
  };
});

export type FullNameSchema = z.infer<typeof fullNameSchema>;

export type TransformFullNameSchema = z.infer<typeof transformFullNameSchema>;
